/* Lightweight analytics helper — wraps PostHog with safe fallbacks */
(function () {
  'use strict';

  function track(event, props) {
    const payload = props || {};
    // PostHog
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(event, payload);
      }
    } catch (e) {}
    // GA4 (gtag)
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', event, payload);
      }
    } catch (e) {}
    // GTM dataLayer (for any other tag routing)
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, payload));
    } catch (e) {}
  }

  function identify(id, props) {
    try {
      if (window.posthog && typeof window.posthog.identify === 'function') {
        window.posthog.identify(String(id), props || {});
      }
    } catch (e) {}
  }

  // Expose
  window.reasnAnalytics = { track: track, identify: identify };

  // Impression tracking via IntersectionObserver
  // Usage: <div data-track-impression="hero_section_viewed" data-track-prop-section="..."> ...
  // Fires once per element per page load when ≥50% visible.
  function setupImpressionObserver() {
    if (!('IntersectionObserver' in window)) return;
    const seen = new WeakSet();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        const el = entry.target;
        if (seen.has(el)) return;
        seen.add(el);
        const event = el.getAttribute('data-track-impression');
        if (!event) return;
        const props = {};
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name.indexOf('data-track-prop-') === 0) {
            props[attr.name.slice('data-track-prop-'.length)] = attr.value;
          }
        });
        track(event, props);
        io.unobserve(el);
      });
    }, { threshold: [0, 0.5, 1] });

    document.querySelectorAll('[data-track-impression]').forEach((el) => io.observe(el));

    // Watch for elements added later (cart drawer suggestions, infinite scroll, etc.)
    const mo = new MutationObserver((muts) => {
      muts.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (!(n instanceof Element)) return;
          if (n.matches && n.matches('[data-track-impression]')) io.observe(n);
          if (n.querySelectorAll) {
            n.querySelectorAll('[data-track-impression]').forEach((el) => io.observe(el));
          }
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupImpressionObserver);
  } else {
    setupImpressionObserver();
  }

  // Mobile drawer + link click tracking
  document.addEventListener('DOMContentLoaded', function () {
    const mobileDrawer = document.getElementById('Details-menu-drawer-container');
    if (mobileDrawer) {
      mobileDrawer.addEventListener('toggle', function () {
        if (mobileDrawer.open) {
          track('drawer_opened', { surface: 'mobile' });
        }
      });
    }

    // Mobile drawer sub-reveal — any nested details inside the menu drawer
    document.querySelectorAll('#menu-drawer details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          const summary = d.querySelector('summary');
          track('drawer_sub_revealed', {
            surface: 'mobile',
            parent: summary ? (summary.textContent || '').trim() : ''
          });
        }
      });
    });

    // Mobile drawer link clicks
    const drawerEl = document.getElementById('menu-drawer');
    if (drawerEl) {
      drawerEl.addEventListener('click', function (e) {
        const link = e.target.closest('a');
        if (!link || !drawerEl.contains(link)) return;
        track('drawer_link_clicked', {
          surface: 'mobile',
          label: (link.textContent || '').trim(),
          href: link.getAttribute('href') || ''
        });
      });
    }

    // Cart drawer open tracking (cart-drawer custom element opens via class change)
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const cartObserver = new MutationObserver(function () {
        if (cartDrawer.classList.contains('active')) {
          track('cart_drawer_opened', { source: 'auto' });
        }
      });
      cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    // Checkout button click in cart
    document.addEventListener('click', function (e) {
      const checkoutBtn = e.target.closest('[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button');
      if (checkoutBtn) {
        const totalEl = document.querySelector('[data-cart-total], .totals__total-value');
        track('cart_checkout_clicked', {
          total_text: totalEl ? totalEl.textContent.trim() : ''
        });
      }
    });

    // Predictive search result click
    document.addEventListener('click', function (e) {
      const item = e.target.closest('predictive-search .predictive-search__list-item a');
      if (item) {
        const list = item.closest('predictive-search');
        const input = list ? list.querySelector('input[type="search"]') : null;
        const items = list ? Array.from(list.querySelectorAll('.predictive-search__list-item a')) : [];
        track('search_predictive_result_clicked', {
          query: input ? input.value : '',
          target: item.getAttribute('href') || '',
          position: items.indexOf(item) + 1
        });
      }
    });

    // Express checkout buttons (Shop Pay / PayPal / Apple Pay etc.)
    document.addEventListener('click', function (e) {
      const expressBtn = e.target.closest('.shopify-payment-button, [data-shopify="payment-button"]');
      if (expressBtn) {
        track('cart_express_checkout_clicked', { provider: 'shopify_dynamic' });
      }
    });
  });

  // Convenience: delegate global click tracking via [data-track]
  // Usage: <button data-track="cart_suggestion_clicked" data-track-prop-product="123">
  document.addEventListener('click', function (e) {
    const el = e.target.closest('[data-track]');
    if (!el) return;
    const event = el.getAttribute('data-track');
    if (!event) return;
    const props = {};
    Array.from(el.attributes).forEach(function (attr) {
      if (attr.name.indexOf('data-track-prop-') === 0) {
        const key = attr.name.slice('data-track-prop-'.length);
        props[key] = attr.value;
      }
    });
    track(event, props);
  });
})();
